<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/LOGO.png" />
        <div class="text">
          丨 一站式综合服务性平台
        </div>
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="selector" v-show="selectorType">
      <div v-for="(item, index) in navList" :key="index">
        <div class="Item" v-if="item.children.length > 0">
          <div v-for="(i, n) in item.children" :key="n">
            <div
              class="Content wow fadeIn"
              @click="rouer(i.path, n)"
              :class="n == selectornavIndex ? 'selectorActive' : ''"
            >
              {{ i.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "Header",
  data() {
    return {
      selectorType: false,
      selectornavIndex: 0,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "关于技森",
          path: "/about",
          children: []
        },
        {
          name: "产品服务",
          path: "/services/appDev",
          children: [
            {
              name: "APP开发",
              path: "/services/appDev",
              children: []
            },
            {
              name: "小程序定制",
              path: "/services/appletDev",
              children: []
            },
            {
              name: "网页开发",
              path: "/services/webDev",
              children: []
            },
            {
              name: "软件开发",
              path: "/services/softwareDev",
              children: []
            }
          ]
        },
        {
          name: "联系我们 ",
          path: "/contact",
          children: []
        }
      ]
    };
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
  },
  watch: {
    $route: {
      handler: function(route) {
        if (route.name == "home") this.navIndex = 0;
        else if (route.name == "about") this.navIndex = 1;
        else if (route.name == "appDev") this.navIndex = 2;
        else if (route.name == "appletDev") this.navIndex = 2;
        else if (route.name == "webDev") this.navIndex = 2;
        else if (route.name == "softwareDev") this.navIndex = 2;
        else if (route.name == "contact") this.navIndex = 3;
      },
      immediate: true
    }
  },
  methods: {
    rouer(path, index) {
      // 当页面的路由与跳转的路由不一致时才允许跳转
      if (this.$route.path !== path) {
        this.$router.push(path);
        this.selectornavIndex = index;
        sessionStorage.setItem("selectornavIndex", index);
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      if (name == "产品服务") {
        (this.selectornavIndex = 0), (this.selectorType = !this.selectorType);
      } else {
        this.selectorType = false;
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
  height: 100px;
}
.selector .Item .Content a {
  width: 100%;
  height: 100%;
}
.selector .Item .Content {
  margin: 0px 23px 0px 23px;
  width: 282px;
  height: 60px;
  background: #f7f8fa;
  border-radius: 4px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #484c58;
  line-height: 60px;
  cursor: pointer;
  border: 1px solid #f7f8fa;
}
.selector .Item .selectorActive {
  background: #f7f8fa;
  border: 1px solid #2a95fe;
  color: #2a95fe;
}
.selector .Item {
  display: flex;
  justify-content: space-evenly;
  margin: auto;
  text-align: center;
}
.selector {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fff;
  display: flex;
  position: relative;
  z-index: 1;
  padding: 40px;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 100px;
  display: flex;
  justify-content: space-between;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 100px; */
  height: 100%;
  float: left;
  position: relative;
  display: flex;
  margin-right: auto;
}

#header .header-nav-logo .text {
  width: 231px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #70747d;
  line-height: 100px;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 136px;
  height: 34px;
  margin-top: 32px;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 100px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  padding: 15px 0;
  position: relative;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #282d3b;
  margin-left: 30px;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #2a95fe;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #2a95fe;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #2a95fe;
  text-decoration: none;
  border-bottom: 2px solid #2a95fe;
  margin-left: 30px;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue